// Sensor
export const SuppSensorSS = [
  { id: 1, name: 'HLZ020XXX', text: '2.0" Sensor', size: '2.0' },
  { id: 2, name: 'HLZ024XXX', text: '2.4" Sensor', size: '2.4' },
  { id: 3, name: 'HLZ027XXX', text: '2.7" Sensor', size: '2.7' },
  { id: 4, name: 'HLZ030XXX', text: '3.0" Sensor', size: '3.0' },
  { id: 5, name: 'HLZ035XXX', text: '3.5" Sensor', size: '3.5' },
  { id: 6, name: 'HLZ040XXX', text: '4.0" Sensor', size: '4.0' },
  { id: 7, name: 'HLZ043XXX', text: '4.3" Sensor', size: '4.3' }
];

export const SuppSensorSM = [
  { id: 1, name: 'HLZ050XXX', text: '5.0" Sensor', size: '5.0' },
  { id: 2, name: 'HLZ055XXX', text: '5.5" Sensor', size: '5.5' },
  { id: 3, name: 'HLZ060XXX', text: '6.0" Sensor', size: '6.0' },
  { id: 4, name: 'HLZ065XXX', text: '6.5" Sensor', size: '6.5' },
  { id: 5, name: 'HLZ070XXX', text: '7.0" Sensor', size: '7.0' },
];

export const SuppSensorMM = [
  { id: 1, name: 'HLZ080XXX', text: '8.0" Sensor', size: '8.0' },
  { id: 2, name: 'HLZ090XXX', text: '9.0" Sensor', size: '9.0' },
  { id: 3, name: 'HLZ101XXX', text: '10.1" Sensor', size: '10.1' },
  { id: 4, name: 'HLZ104XXX', text: '10.4" Sensor', size: '10.4' },
  { id: 5, name: 'HLZ116XXX', text: '11.6" Sensor', size: '11.6' },
  { id: 6, name: 'HLZ123XXX', text: '12.3" Sensor', size: '12.3' },
];

export const SuppSensorML = [
  { id: 1, name: 'HLZ133XXX', text: '13.3" Sensor', size: '13.3' },
  { id: 2, name: 'HLZ140XXX', text: '14.0" Sensor', size: '14.0' },
  { id: 3, name: 'HLZ150XXX', text: '15.0" Sensor', size: '15.0' },
  { id: 4, name: 'HLZ156XXX', text: '15.6" Sensor', size: '15.6' },
  { id: 5, name: 'HLZ170XXX', text: '17.0" Sensor', size: '17.0' },
  { id: 6, name: 'HLZ173XXX', text: '17.3" Sensor', size: '17.3' },
  { id: 7, name: 'HLZ185XXX', text: '18.5" Sensor', size: '18.5' },
];

export const SuppSensorLL = [
  { id: 1, name: 'HLZ190XXX', text: '19.0" Sensor', size: '19.0' },
  { id: 2, name: 'HLZ201XXX', text: '20.1" Sensor', size: '20.1' },
  { id: 3, name: 'HLZ215XXX', text: '21.5" Sensor', size: '21.5' },
  { id: 4, name: 'HLZ230XXX', text: '23.0" Sensor', size: '23.0' },
  { id: 5, name: 'HLZ238XXX', text: '23.8" Sensor', size: '23.8' },
  { id: 6, name: 'HLZ270XXX', text: '27.0" Sensor', size: '27.0' },
];

export const SuppSensorXL = [
  { id: 1, name: 'HLZ320XXX', text: '32.0" Sensor', size: '32.0' },
  { id: 2, name: 'HLZ430XXX', text: '43.0" Sensor', size: '43.0' },
  { id: 3, name: 'HLZ550XXX', text: '55.0" Sensor', size: '55.0' },
  { id: 4, name: 'HLZ650XXX', text: '65.0" Sensor', size: '65.0' },
];

// Touch
export const SuppTouchCon = [
  { id: 1, name: 'HCTP070XXX', text: '7.0" Touch Panel', size: '7.0' },
  { id: 2, name: 'HCTP080XXX', text: '8.0" Touch Panel', size: '8.0' },
  { id: 3, name: 'HCTP090XXX', text: '9.0" Touch Panel', size: '9.0' },
  { id: 4, name: 'HCTP101XXX', text: '10.1" Touch Panel', size: '10.1' },
  { id: 5, name: 'HCTP104XXX', text: '10.4" Touch Panel', size: '10.4' },
  { id: 6, name: 'HCTP123XXX', text: '12.3" Touch Panel', size: '12.3' },
  { id: 7, name: 'HCTP133XXX', text: '13.3" Touch Panel', size: '13.3' },
];

export const SuppTouchCar = [
  { id: 1, name: 'HCTP080XXX', text: '8.0" Touch Panel', size: '8.0' },
  { id: 2, name: 'HCTP090XXX', text: '9.0" Touch Panel', size: '9.0' },
  { id: 3, name: 'HCTP101XXX', text: '10.1" Touch Panel', size: '10.1' },
  { id: 4, name: 'HCTP103XXX', text: '10.25" Touch Panel', size: '10.3' },
  { id: 5, name: 'HCTP123XXX', text: '12.3" Touch Panel', size: '12.3' },
];

export const SuppTouchHmi = [
  { id: 1, name: 'HCTP080XXX', text: '8.0" Touch Panel', size: '8.0' },
  { id: 2, name: 'HCTP090XXX', text: '9.0" Touch Panel', size: '9.0' },
  { id: 3, name: 'HCTP101XXX', text: '10.1" Touch Panel', size: '10.1' },
  { id: 4, name: 'HCTP104XXX', text: '10.4" Touch Panel', size: '10.4' },
  { id: 5, name: 'HCTP116XXX', text: '11.6" Touch Panel', size: '11.6' },
  { id: 6, name: 'HCTP123XXX', text: '12.3" Touch Panel', size: '12.3' },
  { id: 7, name: 'HCTP133XXX', text: '13.3" Touch Panel', size: '13.3' },
];

export const SuppTouchInd = [
  { id: 1, name: 'HCTP150XXX', text: '15.0" Touch Panel', size: '15.0' },
  { id: 2, name: 'HCTP156XXX', text: '15.6" Touch Panel', size: '15.6' },
  { id: 3, name: 'HCTP170XXX', text: '17.0" Touch Panel', size: '17.0' },
  { id: 4, name: 'HCTP173XXX', text: '17.3" Touch Panel', size: '17.3' },
  { id: 5, name: 'HCTP185XXX', text: '18.5" Touch Panel', size: '18.5' },
  { id: 6, name: 'HCTP190XXX', text: '19.0" Touch Panel', size: '19.0' },
];

export const SuppTouchLag = [
  { id: 1, name: 'HCTP200XXX', text: '20.0" Touch Panel', size: '20.0' },
  { id: 2, name: 'HCTP215XXX', text: '21.5" Touch Panel', size: '21.5' },
  { id: 3, name: 'HCTP230XXX', text: '23.0" Touch Panel', size: '23.0' },
  { id: 4, name: 'HCTP238XXX', text: '23.8" Touch Panel', size: '23.8' },
  { id: 5, name: 'HCTP270XXX', text: '27.0" Touch Panel', size: '27.0' },
  { id: 6, name: 'HCTP320XXX', text: '32.0" Touch Panel', size: '32.0' },
  { id: 7, name: 'HCTP430XXX', text: '43.0" Touch Panel', size: '43.0' },
];

// Touch Dipsplay
export const SuppTouchLcm10 = [
  { id: 1, name: 'HTDS101XX1', text: '10.1" Touch LCM', size: '10.1' },
  { id: 2, name: 'HTDS101XX2', text: '10.1" Touch LCM', size: '10.1' },
  { id: 3, name: 'HTDS103XX1', text: '10.3" Touch LCM', size: '10.3' },
];

export const SuppTouchLcm12 = [
  { id: 1, name: 'HTDS121XX1', text: '12.1" Touch LCM', size: '12.1' },
  { id: 1, name: 'HTDS123XX1', text: '12.3" Touch LCM', size: '12.3' },
  { id: 2, name: 'HTDS123XX2', text: '12.3" Touch LCM', size: '12.3' },
];

export const SuppTouchLcm15 = [
  { id: 1, name: 'HTDS150XX1', text: '15.0" Touch LCM', size: '15.0' },
  { id: 2, name: 'HTDS150XX2', text: '15.0" Touch LCM', size: '15.0' },
  { id: 3, name: 'HTDS156XX1', text: '15.6" Touch LCM', size: '15.6' },
  { id: 4, name: 'HTDS156XX2', text: '15.6" Touch LCM', size: '15.6' },
];

export const SuppTouchLcm18 = [
  { id: 1, name: 'HTDS183XX1', text: '18.3" Touch LCM', size: '18.3' },
  { id: 2, name: 'HTDS185XX1', text: '18.5" Touch LCM', size: '18.5' },
  { id: 3, name: 'HTDS185XX2', text: '18.5" Touch LCM', size: '18.5' },
  { id: 4, name: 'HTDS190XX1', text: '19.0" Touch LCM', size: '19.0' },
];

export const SuppTouchLcm21 = [
  { id: 1, name: 'HTDS215XX1', text: '21.5" Touch LCM', size: '21.5' },
  { id: 2, name: 'HTDS215XX2', text: '21.5" Touch LCM', size: '21.5' },
  { id: 3, name: 'HTDS236XX1', text: '23.6" Touch LCM', size: '23.6' },
  { id: 4, name: 'HTDS236XX2', text: '23.6" Touch LCM', size: '23.6' },
];
